module.exports = __webpack_public_path__ + "img/SKMJ_stair.dffdfcfb.jpg";